<template>
  <div class="custom-main custom-theme" style="margin: 0px;">
    <a-form class="ant-advanced-search-form">
      <a-row class="searchrow width-style-auto">
          <a-col span="8">
              <a-form-item :colon="false" label="审方时间">
                  <a-date-picker v-model="search.startDate" placeholder="请选择审方开始时间" style="width: 150px;"/>至<a-date-picker v-model="search.endDate" placeholder="请选择审方结束时间" style="width: 150px;"/>
              </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="审方结果">
              <a-select v-model="search.adopted" placeholder="请选择审方结果">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="true">通过</a-select-option>
                <a-select-option value="false">不通过</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
              <a-form-item style="float: right;" :colon="false">
                  <span slot="label" class="search-label">搜索</span>
                  <a-input v-model="search.keyword" placeholder="请输入患者姓名模糊检索">
                      <img slot="addonAfter" src="../../../assets/img/search.png" style="height:32px;object-fit: cover;cursor: pointer;" @click="searchAction"/>
                  </a-input>
              </a-form-item>
          </a-col>
      </a-row>
    </a-form>
    <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}" rowKey="id" :dataSource="grid.data"
             :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
        <span slot="index" slot-scope="text, record, index">
           {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
        </span>
        <span slot="adopted" slot-scope="text, record, index">
          <a-tag v-if="record.adopted" color="#108ee9">通过</a-tag>
          <a-tag v-else color="#f50">不通过</a-tag>
        </span>
        <span slot="operate" slot-scope="text, record, index">
          <img src="../../../assets/img/detail.png" style="margin-right: 9px;cursor:pointer;user-select: none;" @click="()=>detailAction(record.id)"/>
        </span>
    </a-table>
    <outpatient-drawer ref="outpatientDrawer"/>
  </div>
</template>
<script>
import OutpatientDrawer from '@/components/outpatient/OutpatientDrawer.vue';
export default {
  name: "ExaminedOutpatient",
  components: {
    OutpatientDrawer
  },
  data() {
    return {
      loading: false,
      current:{},
      search:{
        startDate:'',
        endDate:'',
        adopted:'',
        keyword:''
      },
      grid: {
        loading: false,
        columns: columns,
        data: [],
        pagination: this.$pagination
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "远程辅诊",
      path: ""
    },{
      text: "远程审方",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.searchAction();
  },
  methods:{
    detailAction:function (id){
      this.$refs.outpatientDrawer.showAction(id);
    },
    buildParams:function (){
      let startDate ='', endDate='';
      if(undefined != this.search.startDate && null != this.search.startDate && '' != this.search.startDate){
        startDate = this.formatDate(new Date(this.search.startDate));
      }
      if(undefined != this.search.endDate && null != this.search.endDate && '' != this.search.endDate){
        endDate = this.formatDate(new Date(this.search.endDate));
      }
      return {
        'startDate' : startDate, 'endDate' : endDate, 'entity.keyword' : this.search.keyword,
        'entity.adopted' : this.search.adopted
      };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid:function(params){
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/roam/examined/outpatients', {params: params}).then(function(res){
        self.grid.loading = false;
        if(res.msg.flag == 0){
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          }else{
            Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.grid.loading = false;
      });
    }
  }
}

const columns =[
  {
    title: '序号',
    align: 'center',
    scopedSlots: {customRender: 'index'},
    width: 60
  },
  {
    title: '门诊单号',
    dataIndex: 'code',
    key: 'code',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '患者姓名',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '性别',
    dataIndex: 'sex',
    key: 'sex',
    width: 80,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '年龄',
    dataIndex: 'age',
    key: 'age',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊类型',
    dataIndex: 'visitType',
    key: 'visitType',
    align: 'center',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊医院',
    dataIndex: 'organ',
    key: 'organ',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊科室',
    dataIndex: 'department',
    key: 'department',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊医生',
    dataIndex: 'doctor',
    key: 'doctor',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '开方时间',
    dataIndex: 'recipeTime',
    key: 'recipeTime',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '审方时间',
    dataIndex: 'examineTime',
    key: 'examineTime',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '诊断疾病',
    dataIndex: 'diagnostic',
    key: 'diagnostic',
    width: 200,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '详细地址',
    dataIndex: 'address',
    key: 'address',
    width: 200,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '审方结果',
    key: 'adopted',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'adopted'}
  },
  {
    title: '操作',
    key: 'id',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'operate'}
  }
]
</script>

<style scoped>
</style>
